module.exports = {"431022101":"白石渡镇","431022102":"杨梅山镇","431022103":"瑶岗仙镇","431022104":"梅田镇","431022106":"黄沙镇","431022107":"迎春镇","431022108":"一六镇","431022109":"栗源镇","431022110":"岩泉镇","431022111":"玉溪镇","431022112":"天塘镇","431022113":"笆篱镇","431022114":"里田镇","431022115":"五岭镇","431022201":"浆水乡","431022202":"长村乡","431022205":"莽山瑶族乡","431022208":"关溪乡","431022212":"赤石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431022.json
// module id = 2020
// module chunks = 0